'use client';
"use strict";

var _excluded = ["ratio", "children", "className"],
  _excluded2 = ["className"],
  _excluded3 = ["size", "centerContent"],
  _excluded4 = ["size"],
  _excluded5 = ["axis"],
  _excluded6 = ["className"],
  _excluded7 = ["className", "centerContent"],
  _excluded8 = ["borderLeftWidth", "borderBottomWidth", "borderTopWidth", "borderRightWidth", "borderWidth", "borderStyle", "borderColor"],
  _excluded9 = ["className", "orientation", "__css"],
  _excluded10 = ["direction", "align", "justify", "wrap", "basis", "grow", "shrink"],
  _excluded11 = ["templateAreas", "gap", "rowGap", "columnGap", "column", "row", "autoFlow", "autoRows", "templateRows", "autoColumns", "templateColumns"],
  _excluded12 = ["area", "colSpan", "colStart", "colEnd", "rowEnd", "rowSpan", "rowStart"],
  _excluded13 = ["className"],
  _excluded14 = ["className"],
  _excluded15 = ["className", "isExternal"],
  _excluded16 = ["isExternal", "target", "rel", "className"],
  _excluded17 = ["className"],
  _excluded18 = ["children", "styleType", "stylePosition", "spacing"],
  _excluded19 = ["as"],
  _excluded20 = ["as"],
  _excluded21 = ["columns", "spacingX", "spacingY", "spacing", "minChildWidth"],
  _excluded22 = ["isInline", "direction", "align", "justify", "spacing", "wrap", "children", "divider", "className", "shouldWrapChildren"],
  _excluded23 = ["className", "align", "decoration", "casing"],
  _excluded24 = ["spacing", "spacingX", "spacingY", "children", "justify", "direction", "align", "className", "shouldWrapChildren"],
  _excluded25 = ["className"],
  _excluded26 = ["offsetX", "offsetY", "offset", "placement"];
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && _typeof(from) === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step;
    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return to;
};
var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};

// src/index.ts
var src_exports = {};
__export(src_exports, {
  AbsoluteCenter: function AbsoluteCenter() {
    return _AbsoluteCenter;
  },
  AspectRatio: function AspectRatio() {
    return _AspectRatio;
  },
  Badge: function Badge() {
    return _Badge;
  },
  Box: function Box() {
    return _Box;
  },
  Center: function Center() {
    return _Center;
  },
  Circle: function Circle() {
    return _Circle;
  },
  Code: function Code() {
    return _Code;
  },
  Container: function Container() {
    return _Container;
  },
  Divider: function Divider() {
    return _Divider;
  },
  Flex: function Flex() {
    return _Flex;
  },
  Grid: function Grid() {
    return _Grid;
  },
  GridItem: function GridItem() {
    return _GridItem;
  },
  HStack: function HStack() {
    return _HStack;
  },
  Heading: function Heading() {
    return _Heading;
  },
  Highlight: function Highlight() {
    return _Highlight;
  },
  Indicator: function Indicator() {
    return _Indicator;
  },
  Kbd: function Kbd() {
    return _Kbd;
  },
  Link: function Link() {
    return _Link;
  },
  LinkBox: function LinkBox() {
    return _LinkBox;
  },
  LinkOverlay: function LinkOverlay() {
    return _LinkOverlay;
  },
  List: function List() {
    return _List;
  },
  ListIcon: function ListIcon() {
    return _ListIcon;
  },
  ListItem: function ListItem() {
    return _ListItem;
  },
  Mark: function Mark() {
    return _Mark;
  },
  OrderedList: function OrderedList() {
    return _OrderedList;
  },
  SimpleGrid: function SimpleGrid() {
    return _SimpleGrid;
  },
  Spacer: function Spacer() {
    return _Spacer;
  },
  Square: function Square() {
    return _Square;
  },
  Stack: function Stack() {
    return _Stack;
  },
  StackDivider: function StackDivider() {
    return _StackDivider;
  },
  StackItem: function StackItem() {
    return _StackItem;
  },
  Text: function Text() {
    return _Text;
  },
  UnorderedList: function UnorderedList() {
    return _UnorderedList;
  },
  VStack: function VStack() {
    return _VStack;
  },
  Wrap: function Wrap() {
    return _Wrap;
  },
  WrapItem: function WrapItem() {
    return _WrapItem;
  },
  useHighlight: function useHighlight() {
    return _useHighlight;
  },
  useListStyles: function useListStyles() {
    return _useListStyles;
  }
});
module.exports = __toCommonJS(src_exports);

// src/aspect-ratio.tsx
var import_system = require("@chakra-ui/system");
var import_breakpoint_utils = require("@chakra-ui/breakpoint-utils");
var import_shared_utils = require("@chakra-ui/shared-utils");
var import_react = require("react");
var import_jsx_runtime = require("react/jsx-runtime");
var _AspectRatio = (0, import_system.forwardRef)(function (props, ref) {
  var _props$ratio = props.ratio,
    ratio = _props$ratio === void 0 ? 4 / 3 : _props$ratio,
    children = props.children,
    className = props.className,
    rest = _objectWithoutProperties(props, _excluded);
  var child = import_react.Children.only(children);
  var _className = (0, import_shared_utils.cx)("chakra-aspect-ratio", className);
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_system.chakra.div, _objectSpread(_objectSpread({
    ref: ref,
    position: "relative",
    className: _className,
    _before: {
      height: 0,
      content: "\"\"",
      display: "block",
      paddingBottom: (0, import_breakpoint_utils.mapResponsive)(ratio, function (r) {
        return "".concat(1 / r * 100, "%");
      })
    },
    __css: {
      "& > *:not(style)": {
        overflow: "hidden",
        position: "absolute",
        top: "0",
        right: "0",
        bottom: "0",
        left: "0",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100%"
      },
      "& > img, & > video": {
        objectFit: "cover"
      }
    }
  }, rest), {}, {
    children: child
  }));
});
_AspectRatio.displayName = "AspectRatio";

// src/badge.tsx
var import_system2 = require("@chakra-ui/system");
var import_shared_utils2 = require("@chakra-ui/shared-utils");
var import_jsx_runtime2 = require("react/jsx-runtime");
var _Badge = (0, import_system2.forwardRef)(function Badge2(props, ref) {
  var styles = (0, import_system2.useStyleConfig)("Badge", props);
  var _ref = (0, import_system2.omitThemingProps)(props),
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded2);
  return /* @__PURE__ */(0, import_jsx_runtime2.jsx)(import_system2.chakra.span, _objectSpread(_objectSpread({
    ref: ref,
    className: (0, import_shared_utils2.cx)("chakra-badge", props.className)
  }, rest), {}, {
    __css: _objectSpread({
      display: "inline-block",
      whiteSpace: "nowrap",
      verticalAlign: "middle"
    }, styles)
  }));
});
_Badge.displayName = "Badge";

// src/box.tsx
var import_system3 = require("@chakra-ui/system");
var import_jsx_runtime3 = require("react/jsx-runtime");
var _Box = (0, import_system3.chakra)("div");
_Box.displayName = "Box";
var _Square = (0, import_system3.forwardRef)(function Square2(props, ref) {
  var size = props.size,
    _props$centerContent = props.centerContent,
    centerContent = _props$centerContent === void 0 ? true : _props$centerContent,
    rest = _objectWithoutProperties(props, _excluded3);
  var styles = centerContent ? {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  } : {};
  return /* @__PURE__ */(0, import_jsx_runtime3.jsx)(_Box, _objectSpread({
    ref: ref,
    boxSize: size,
    __css: _objectSpread(_objectSpread({}, styles), {}, {
      flexShrink: 0,
      flexGrow: 0
    })
  }, rest));
});
_Square.displayName = "Square";
var _Circle = (0, import_system3.forwardRef)(function Circle2(props, ref) {
  var size = props.size,
    rest = _objectWithoutProperties(props, _excluded4);
  return /* @__PURE__ */(0, import_jsx_runtime3.jsx)(_Square, _objectSpread({
    size: size,
    ref: ref,
    borderRadius: "9999px"
  }, rest));
});
_Circle.displayName = "Circle";

// src/center.tsx
var import_system4 = require("@chakra-ui/system");
var import_jsx_runtime4 = require("react/jsx-runtime");
var _Center = (0, import_system4.chakra)("div", {
  baseStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }
});
_Center.displayName = "Center";
var centerStyles = {
  horizontal: {
    insetStart: "50%",
    transform: "translateX(-50%)"
  },
  vertical: {
    top: "50%",
    transform: "translateY(-50%)"
  },
  both: {
    insetStart: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)"
  }
};
var _AbsoluteCenter = (0, import_system4.forwardRef)(function AbsoluteCenter2(props, ref) {
  var _props$axis = props.axis,
    axis = _props$axis === void 0 ? "both" : _props$axis,
    rest = _objectWithoutProperties(props, _excluded5);
  return /* @__PURE__ */(0, import_jsx_runtime4.jsx)(import_system4.chakra.div, _objectSpread(_objectSpread({
    ref: ref,
    __css: centerStyles[axis]
  }, rest), {}, {
    position: "absolute"
  }));
});

// src/code.tsx
var import_system5 = require("@chakra-ui/system");
var import_shared_utils3 = require("@chakra-ui/shared-utils");
var import_jsx_runtime5 = require("react/jsx-runtime");
var _Code = (0, import_system5.forwardRef)(function Code2(props, ref) {
  var styles = (0, import_system5.useStyleConfig)("Code", props);
  var _ref2 = (0, import_system5.omitThemingProps)(props),
    className = _ref2.className,
    rest = _objectWithoutProperties(_ref2, _excluded6);
  return /* @__PURE__ */(0, import_jsx_runtime5.jsx)(import_system5.chakra.code, _objectSpread(_objectSpread({
    ref: ref,
    className: (0, import_shared_utils3.cx)("chakra-code", props.className)
  }, rest), {}, {
    __css: _objectSpread({
      display: "inline-block"
    }, styles)
  }));
});
_Code.displayName = "Code";

// src/container.tsx
var import_system6 = require("@chakra-ui/system");
var import_shared_utils4 = require("@chakra-ui/shared-utils");
var import_jsx_runtime6 = require("react/jsx-runtime");
var _Container = (0, import_system6.forwardRef)(function Container2(props, ref) {
  var _ref3 = (0, import_system6.omitThemingProps)(props),
    className = _ref3.className,
    centerContent = _ref3.centerContent,
    rest = _objectWithoutProperties(_ref3, _excluded7);
  var styles = (0, import_system6.useStyleConfig)("Container", props);
  return /* @__PURE__ */(0, import_jsx_runtime6.jsx)(import_system6.chakra.div, _objectSpread(_objectSpread({
    ref: ref,
    className: (0, import_shared_utils4.cx)("chakra-container", className)
  }, rest), {}, {
    __css: _objectSpread(_objectSpread({}, styles), centerContent && {
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    })
  }));
});
_Container.displayName = "Container";

// src/divider.tsx
var import_system7 = require("@chakra-ui/system");
var import_shared_utils5 = require("@chakra-ui/shared-utils");
var import_jsx_runtime7 = require("react/jsx-runtime");
var _Divider = (0, import_system7.forwardRef)(function Divider2(props, ref) {
  var _ref4 = (0, import_system7.useStyleConfig)("Divider", props),
    borderLeftWidth = _ref4.borderLeftWidth,
    borderBottomWidth = _ref4.borderBottomWidth,
    borderTopWidth = _ref4.borderTopWidth,
    borderRightWidth = _ref4.borderRightWidth,
    borderWidth = _ref4.borderWidth,
    borderStyle = _ref4.borderStyle,
    borderColor = _ref4.borderColor,
    styles = _objectWithoutProperties(_ref4, _excluded8);
  var _ref5 = (0, import_system7.omitThemingProps)(props),
    className = _ref5.className,
    _ref5$orientation = _ref5.orientation,
    orientation = _ref5$orientation === void 0 ? "horizontal" : _ref5$orientation,
    __css = _ref5.__css,
    rest = _objectWithoutProperties(_ref5, _excluded9);
  var dividerStyles = {
    vertical: {
      borderLeftWidth: borderLeftWidth || borderRightWidth || borderWidth || "1px",
      height: "100%"
    },
    horizontal: {
      borderBottomWidth: borderBottomWidth || borderTopWidth || borderWidth || "1px",
      width: "100%"
    }
  };
  return /* @__PURE__ */(0, import_jsx_runtime7.jsx)(import_system7.chakra.hr, _objectSpread(_objectSpread({
    ref: ref,
    "aria-orientation": orientation
  }, rest), {}, {
    __css: _objectSpread(_objectSpread(_objectSpread({}, styles), {}, {
      border: "0",
      borderColor: borderColor,
      borderStyle: borderStyle
    }, dividerStyles[orientation]), __css),
    className: (0, import_shared_utils5.cx)("chakra-divider", className)
  }));
});
_Divider.displayName = "Divider";

// src/flex.tsx
var import_system8 = require("@chakra-ui/system");
var import_jsx_runtime8 = require("react/jsx-runtime");
var _Flex = (0, import_system8.forwardRef)(function Flex2(props, ref) {
  var direction = props.direction,
    align = props.align,
    justify = props.justify,
    wrap = props.wrap,
    basis = props.basis,
    grow = props.grow,
    shrink = props.shrink,
    rest = _objectWithoutProperties(props, _excluded10);
  var styles = {
    display: "flex",
    flexDirection: direction,
    alignItems: align,
    justifyContent: justify,
    flexWrap: wrap,
    flexBasis: basis,
    flexGrow: grow,
    flexShrink: shrink
  };
  return /* @__PURE__ */(0, import_jsx_runtime8.jsx)(import_system8.chakra.div, _objectSpread({
    ref: ref,
    __css: styles
  }, rest));
});
_Flex.displayName = "Flex";

// src/grid.tsx
var import_system9 = require("@chakra-ui/system");
var import_jsx_runtime9 = require("react/jsx-runtime");
var _Grid = (0, import_system9.forwardRef)(function Grid2(props, ref) {
  var templateAreas = props.templateAreas,
    gap = props.gap,
    rowGap = props.rowGap,
    columnGap = props.columnGap,
    column = props.column,
    row = props.row,
    autoFlow = props.autoFlow,
    autoRows = props.autoRows,
    templateRows = props.templateRows,
    autoColumns = props.autoColumns,
    templateColumns = props.templateColumns,
    rest = _objectWithoutProperties(props, _excluded11);
  var styles = {
    display: "grid",
    gridTemplateAreas: templateAreas,
    gridGap: gap,
    gridRowGap: rowGap,
    gridColumnGap: columnGap,
    gridAutoColumns: autoColumns,
    gridColumn: column,
    gridRow: row,
    gridAutoFlow: autoFlow,
    gridAutoRows: autoRows,
    gridTemplateRows: templateRows,
    gridTemplateColumns: templateColumns
  };
  return /* @__PURE__ */(0, import_jsx_runtime9.jsx)(import_system9.chakra.div, _objectSpread({
    ref: ref,
    __css: styles
  }, rest));
});
_Grid.displayName = "Grid";

// src/grid-item.tsx
var import_system10 = require("@chakra-ui/system");
var import_object_utils = require("@chakra-ui/object-utils");
var import_breakpoint_utils2 = require("@chakra-ui/breakpoint-utils");
var import_jsx_runtime10 = require("react/jsx-runtime");
function spanFn(span) {
  return (0, import_breakpoint_utils2.mapResponsive)(span, function (value) {
    return value === "auto" ? "auto" : "span ".concat(value, "/span ").concat(value);
  });
}
var _GridItem = (0, import_system10.forwardRef)(function GridItem2(props, ref) {
  var area = props.area,
    colSpan = props.colSpan,
    colStart = props.colStart,
    colEnd = props.colEnd,
    rowEnd = props.rowEnd,
    rowSpan = props.rowSpan,
    rowStart = props.rowStart,
    rest = _objectWithoutProperties(props, _excluded12);
  var styles = (0, import_object_utils.compact)({
    gridArea: area,
    gridColumn: spanFn(colSpan),
    gridRow: spanFn(rowSpan),
    gridColumnStart: colStart,
    gridColumnEnd: colEnd,
    gridRowStart: rowStart,
    gridRowEnd: rowEnd
  });
  return /* @__PURE__ */(0, import_jsx_runtime10.jsx)(import_system10.chakra.div, _objectSpread({
    ref: ref,
    __css: styles
  }, rest));
});
_GridItem.displayName = "GridItem";

// src/heading.tsx
var import_system11 = require("@chakra-ui/system");
var import_shared_utils6 = require("@chakra-ui/shared-utils");
var import_jsx_runtime11 = require("react/jsx-runtime");
var _Heading = (0, import_system11.forwardRef)(function Heading2(props, ref) {
  var styles = (0, import_system11.useStyleConfig)("Heading", props);
  var _ref6 = (0, import_system11.omitThemingProps)(props),
    className = _ref6.className,
    rest = _objectWithoutProperties(_ref6, _excluded13);
  return /* @__PURE__ */(0, import_jsx_runtime11.jsx)(import_system11.chakra.h2, _objectSpread(_objectSpread({
    ref: ref,
    className: (0, import_shared_utils6.cx)("chakra-heading", props.className)
  }, rest), {}, {
    __css: styles
  }));
});
_Heading.displayName = "Heading";

// src/highlight.tsx
var import_system12 = require("@chakra-ui/system");
var import_react2 = require("react");
var import_jsx_runtime12 = require("react/jsx-runtime");
var escapeRegexp = function escapeRegexp(term) {
  return term.replace(/[|\\{}()[\]^$+*?.-]/g, function (_char) {
    return "\\".concat(_char);
  });
};
function buildRegex(query) {
  var _query = query.filter(function (text) {
    return text.length !== 0;
  }).map(function (text) {
    return escapeRegexp(text.trim());
  });
  if (!_query.length) {
    return null;
  }
  return new RegExp("(".concat(_query.join("|"), ")"), "ig");
}
function highlightWords(_ref7) {
  var text = _ref7.text,
    query = _ref7.query;
  var regex = buildRegex(Array.isArray(query) ? query : [query]);
  if (!regex) {
    return [{
      text: text,
      match: false
    }];
  }
  var result = text.split(regex).filter(Boolean);
  return result.map(function (str) {
    return {
      text: str,
      match: regex.test(str)
    };
  });
}
function _useHighlight(props) {
  var text = props.text,
    query = props.query;
  return (0, import_react2.useMemo)(function () {
    return highlightWords({
      text: text,
      query: query
    });
  }, [text, query]);
}
var _Mark = (0, import_system12.forwardRef)(function Mark2(props, ref) {
  var styles = (0, import_system12.useStyleConfig)("Mark", props);
  var ownProps = (0, import_system12.omitThemingProps)(props);
  return /* @__PURE__ */(0, import_jsx_runtime12.jsx)(_Box, _objectSpread(_objectSpread({
    ref: ref
  }, ownProps), {}, {
    as: "mark",
    __css: _objectSpread({
      bg: "transparent",
      whiteSpace: "nowrap"
    }, styles)
  }));
});
function _Highlight(props) {
  var children = props.children,
    query = props.query,
    styles = props.styles;
  if (typeof children !== "string") {
    throw new Error("The children prop of Highlight must be a string");
  }
  var chunks = _useHighlight({
    query: query,
    text: children
  });
  return /* @__PURE__ */(0, import_jsx_runtime12.jsx)(import_jsx_runtime12.Fragment, {
    children: chunks.map(function (chunk, index) {
      return chunk.match ? /* @__PURE__ */(0, import_jsx_runtime12.jsx)(_Mark, {
        sx: styles,
        children: chunk.text
      }, index) : /* @__PURE__ */(0, import_jsx_runtime12.jsx)(import_react2.Fragment, {
        children: chunk.text
      }, index);
    })
  });
}

// src/kbd.tsx
var import_system13 = require("@chakra-ui/system");
var import_shared_utils7 = require("@chakra-ui/shared-utils");
var import_jsx_runtime13 = require("react/jsx-runtime");
var _Kbd = (0, import_system13.forwardRef)(function Kbd2(props, ref) {
  var styles = (0, import_system13.useStyleConfig)("Kbd", props);
  var _ref8 = (0, import_system13.omitThemingProps)(props),
    className = _ref8.className,
    rest = _objectWithoutProperties(_ref8, _excluded14);
  return /* @__PURE__ */(0, import_jsx_runtime13.jsx)(import_system13.chakra.kbd, _objectSpread(_objectSpread({
    ref: ref,
    className: (0, import_shared_utils7.cx)("chakra-kbd", className)
  }, rest), {}, {
    __css: _objectSpread({
      fontFamily: "mono"
    }, styles)
  }));
});
_Kbd.displayName = "Kbd";

// src/link.tsx
var import_system14 = require("@chakra-ui/system");
var import_shared_utils8 = require("@chakra-ui/shared-utils");
var import_jsx_runtime14 = require("react/jsx-runtime");
var _Link = (0, import_system14.forwardRef)(function Link2(props, ref) {
  var styles = (0, import_system14.useStyleConfig)("Link", props);
  var _ref9 = (0, import_system14.omitThemingProps)(props),
    className = _ref9.className,
    isExternal = _ref9.isExternal,
    rest = _objectWithoutProperties(_ref9, _excluded15);
  return /* @__PURE__ */(0, import_jsx_runtime14.jsx)(import_system14.chakra.a, _objectSpread(_objectSpread({
    target: isExternal ? "_blank" : void 0,
    rel: isExternal ? "noopener" : void 0,
    ref: ref,
    className: (0, import_shared_utils8.cx)("chakra-link", className)
  }, rest), {}, {
    __css: styles
  }));
});
_Link.displayName = "Link";

// src/link-box.tsx
var import_system15 = require("@chakra-ui/system");
var import_shared_utils9 = require("@chakra-ui/shared-utils");
var import_jsx_runtime15 = require("react/jsx-runtime");
var _LinkOverlay = (0, import_system15.forwardRef)(function LinkOverlay2(props, ref) {
  var isExternal = props.isExternal,
    target = props.target,
    rel = props.rel,
    className = props.className,
    rest = _objectWithoutProperties(props, _excluded16);
  return /* @__PURE__ */(0, import_jsx_runtime15.jsx)(import_system15.chakra.a, _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref,
    className: (0, import_shared_utils9.cx)("chakra-linkbox__overlay", className),
    rel: isExternal ? "noopener noreferrer" : rel,
    target: isExternal ? "_blank" : target,
    __css: {
      position: "static",
      "&::before": {
        content: "''",
        cursor: "inherit",
        display: "block",
        position: "absolute",
        top: 0,
        left: 0,
        zIndex: 0,
        width: "100%",
        height: "100%"
      }
    }
  }));
});
var _LinkBox = (0, import_system15.forwardRef)(function LinkBox2(props, ref) {
  var className = props.className,
    rest = _objectWithoutProperties(props, _excluded17);
  return /* @__PURE__ */(0, import_jsx_runtime15.jsx)(import_system15.chakra.div, _objectSpread(_objectSpread({
    ref: ref,
    position: "relative"
  }, rest), {}, {
    className: (0, import_shared_utils9.cx)("chakra-linkbox", className),
    __css: {
      /* Elevate the links and abbreviations up */
      "a[href]:not(.chakra-linkbox__overlay), abbr[title]": {
        position: "relative",
        zIndex: 1
      }
    }
  }));
});

// src/list.tsx
var import_icon = require("@chakra-ui/icon");
var import_react_context = require("@chakra-ui/react-context");
var import_react_children_utils = require("@chakra-ui/react-children-utils");
var import_system16 = require("@chakra-ui/system");
var import_jsx_runtime16 = require("react/jsx-runtime");
var _ref10 = (0, import_react_context.createContext)({
    name: "ListStylesContext",
    errorMessage: "useListStyles returned is 'undefined'. Seems you forgot to wrap the components in \"<List />\" "
  }),
  _ref11 = _slicedToArray(_ref10, 2),
  ListStylesProvider = _ref11[0],
  _useListStyles = _ref11[1];
var _List = (0, import_system16.forwardRef)(function List2(props, ref) {
  var styles = (0, import_system16.useMultiStyleConfig)("List", props);
  var _ref12 = (0, import_system16.omitThemingProps)(props),
    children = _ref12.children,
    _ref12$styleType = _ref12.styleType,
    styleType = _ref12$styleType === void 0 ? "none" : _ref12$styleType,
    stylePosition = _ref12.stylePosition,
    spacing = _ref12.spacing,
    rest = _objectWithoutProperties(_ref12, _excluded18);
  var validChildren = (0, import_react_children_utils.getValidChildren)(children);
  var selector = "& > *:not(style) ~ *:not(style)";
  var spacingStyle = spacing ? _defineProperty({}, selector, {
    mt: spacing
  }) : {};
  return /* @__PURE__ */(0, import_jsx_runtime16.jsx)(ListStylesProvider, {
    value: styles,
    children: /* @__PURE__ */(0, import_jsx_runtime16.jsx)(import_system16.chakra.ul, _objectSpread(_objectSpread({
      ref: ref,
      listStyleType: styleType,
      listStylePosition: stylePosition,
      role: "list",
      __css: _objectSpread(_objectSpread({}, styles.container), spacingStyle)
    }, rest), {}, {
      children: validChildren
    }))
  });
});
_List.displayName = "List";
var _OrderedList = (0, import_system16.forwardRef)(function (props, ref) {
  var as = props.as,
    rest = _objectWithoutProperties(props, _excluded19);
  return /* @__PURE__ */(0, import_jsx_runtime16.jsx)(_List, _objectSpread({
    ref: ref,
    as: "ol",
    styleType: "decimal",
    marginStart: "1em"
  }, rest));
});
_OrderedList.displayName = "OrderedList";
var _UnorderedList = (0, import_system16.forwardRef)(function UnorderedList2(props, ref) {
  var as = props.as,
    rest = _objectWithoutProperties(props, _excluded20);
  return /* @__PURE__ */(0, import_jsx_runtime16.jsx)(_List, _objectSpread({
    ref: ref,
    as: "ul",
    styleType: "initial",
    marginStart: "1em"
  }, rest));
});
_UnorderedList.displayName = "UnorderedList";
var _ListItem = (0, import_system16.forwardRef)(function ListItem2(props, ref) {
  var styles = _useListStyles();
  return /* @__PURE__ */(0, import_jsx_runtime16.jsx)(import_system16.chakra.li, _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    __css: styles.item
  }));
});
_ListItem.displayName = "ListItem";
var _ListIcon = (0, import_system16.forwardRef)(function ListIcon2(props, ref) {
  var styles = _useListStyles();
  return /* @__PURE__ */(0, import_jsx_runtime16.jsx)(import_icon.Icon, _objectSpread(_objectSpread({
    ref: ref,
    role: "presentation"
  }, props), {}, {
    __css: styles.icon
  }));
});
_ListIcon.displayName = "ListIcon";

// src/simple-grid.tsx
var import_system17 = require("@chakra-ui/system");
var import_breakpoint_utils3 = require("@chakra-ui/breakpoint-utils");
var import_jsx_runtime17 = require("react/jsx-runtime");
var _SimpleGrid = (0, import_system17.forwardRef)(function SimpleGrid2(props, ref) {
  var columns = props.columns,
    spacingX = props.spacingX,
    spacingY = props.spacingY,
    spacing = props.spacing,
    minChildWidth = props.minChildWidth,
    rest = _objectWithoutProperties(props, _excluded21);
  var theme = (0, import_system17.useTheme)();
  var templateColumns = minChildWidth ? widthToColumns(minChildWidth, theme) : countToColumns(columns);
  return /* @__PURE__ */(0, import_jsx_runtime17.jsx)(_Grid, _objectSpread({
    ref: ref,
    gap: spacing,
    columnGap: spacingX,
    rowGap: spacingY,
    templateColumns: templateColumns
  }, rest));
});
_SimpleGrid.displayName = "SimpleGrid";
function toPx(n) {
  return typeof n === "number" ? "".concat(n, "px") : n;
}
function widthToColumns(width, theme) {
  return (0, import_breakpoint_utils3.mapResponsive)(width, function (value) {
    var _value = (0, import_system17.getToken)("sizes", value, toPx(value))(theme);
    return value === null ? null : "repeat(auto-fit, minmax(".concat(_value, ", 1fr))");
  });
}
function countToColumns(count) {
  return (0, import_breakpoint_utils3.mapResponsive)(count, function (value) {
    return value === null ? null : "repeat(".concat(value, ", minmax(0, 1fr))");
  });
}

// src/spacer.tsx
var import_system18 = require("@chakra-ui/system");
var _Spacer = (0, import_system18.chakra)("div", {
  baseStyle: {
    flex: 1,
    justifySelf: "stretch",
    alignSelf: "stretch"
  }
});
_Spacer.displayName = "Spacer";

// src/stack/h-stack.tsx
var import_system21 = require("@chakra-ui/system");

// src/stack/stack.tsx
var import_react_children_utils2 = require("@chakra-ui/react-children-utils");
var import_shared_utils10 = require("@chakra-ui/shared-utils");
var import_system20 = require("@chakra-ui/system");
var import_react3 = require("react");

// src/stack/stack-item.tsx
var import_system19 = require("@chakra-ui/system");
var import_jsx_runtime18 = require("react/jsx-runtime");
var _StackItem = function _StackItem(props) {
  return /* @__PURE__ */(0, import_jsx_runtime18.jsx)(import_system19.chakra.div, _objectSpread(_objectSpread({
    className: "chakra-stack__item"
  }, props), {}, {
    __css: _objectSpread({
      display: "inline-block",
      flex: "0 0 auto",
      minWidth: 0
    }, props["__css"])
  }));
};
_StackItem.displayName = "StackItem";

// src/stack/stack.utils.tsx
var import_breakpoint_utils4 = require("@chakra-ui/breakpoint-utils");
function getDividerStyles(options) {
  var spacing = options.spacing,
    direction = options.direction;
  var dividerStyles = {
    column: {
      my: spacing,
      mx: 0,
      borderLeftWidth: 0,
      borderBottomWidth: "1px"
    },
    "column-reverse": {
      my: spacing,
      mx: 0,
      borderLeftWidth: 0,
      borderBottomWidth: "1px"
    },
    row: {
      mx: spacing,
      my: 0,
      borderLeftWidth: "1px",
      borderBottomWidth: 0
    },
    "row-reverse": {
      mx: spacing,
      my: 0,
      borderLeftWidth: "1px",
      borderBottomWidth: 0
    }
  };
  return {
    "&": (0, import_breakpoint_utils4.mapResponsive)(direction, function (value) {
      return dividerStyles[value];
    })
  };
}

// src/stack/stack.tsx
var import_jsx_runtime19 = require("react/jsx-runtime");
var _Stack = (0, import_system20.forwardRef)(function (props, ref) {
  var isInline = props.isInline,
    directionProp = props.direction,
    align = props.align,
    justify = props.justify,
    _props$spacing = props.spacing,
    spacing = _props$spacing === void 0 ? "0.5rem" : _props$spacing,
    wrap = props.wrap,
    children = props.children,
    divider = props.divider,
    className = props.className,
    shouldWrapChildren = props.shouldWrapChildren,
    rest = _objectWithoutProperties(props, _excluded22);
  var direction = isInline ? "row" : directionProp != null ? directionProp : "column";
  var dividerStyle = (0, import_react3.useMemo)(function () {
    return getDividerStyles({
      spacing: spacing,
      direction: direction
    });
  }, [spacing, direction]);
  var hasDivider = !!divider;
  var shouldUseChildren = !shouldWrapChildren && !hasDivider;
  var clones = (0, import_react3.useMemo)(function () {
    var validChildren = (0, import_react_children_utils2.getValidChildren)(children);
    return shouldUseChildren ? validChildren : validChildren.map(function (child, index) {
      var key = typeof child.key !== "undefined" ? child.key : index;
      var isLast = index + 1 === validChildren.length;
      var wrappedChild = /* @__PURE__ */(0, import_jsx_runtime19.jsx)(_StackItem, {
        children: child
      }, key);
      var _child = shouldWrapChildren ? wrappedChild : child;
      if (!hasDivider) return _child;
      var clonedDivider = (0, import_react3.cloneElement)(divider, {
        __css: dividerStyle
      });
      var _divider = isLast ? null : clonedDivider;
      return /* @__PURE__ */(0, import_jsx_runtime19.jsxs)(import_react3.Fragment, {
        children: [_child, _divider]
      }, key);
    });
  }, [divider, dividerStyle, hasDivider, shouldUseChildren, shouldWrapChildren, children]);
  var _className = (0, import_shared_utils10.cx)("chakra-stack", className);
  return /* @__PURE__ */(0, import_jsx_runtime19.jsx)(import_system20.chakra.div, _objectSpread(_objectSpread({
    ref: ref,
    display: "flex",
    alignItems: align,
    justifyContent: justify,
    flexDirection: direction,
    flexWrap: wrap,
    gap: hasDivider ? void 0 : spacing,
    className: _className
  }, rest), {}, {
    children: clones
  }));
});
_Stack.displayName = "Stack";

// src/stack/h-stack.tsx
var import_jsx_runtime20 = require("react/jsx-runtime");
var _HStack = (0, import_system21.forwardRef)(function (props, ref) {
  return /* @__PURE__ */(0, import_jsx_runtime20.jsx)(_Stack, _objectSpread(_objectSpread({
    align: "center"
  }, props), {}, {
    direction: "row",
    ref: ref
  }));
});
_HStack.displayName = "HStack";

// src/stack/stack-divider.tsx
var import_system22 = require("@chakra-ui/system");
var import_jsx_runtime21 = require("react/jsx-runtime");
var _StackDivider = function _StackDivider(props) {
  return /* @__PURE__ */(0, import_jsx_runtime21.jsx)(import_system22.chakra.div, _objectSpread(_objectSpread({
    className: "chakra-stack__divider"
  }, props), {}, {
    __css: _objectSpread(_objectSpread({}, props["__css"]), {}, {
      borderWidth: 0,
      alignSelf: "stretch",
      borderColor: "inherit",
      width: "auto",
      height: "auto"
    })
  }));
};
_StackDivider.displayName = "StackDivider";

// src/stack/v-stack.tsx
var import_system23 = require("@chakra-ui/system");
var import_jsx_runtime22 = require("react/jsx-runtime");
var _VStack = (0, import_system23.forwardRef)(function (props, ref) {
  return /* @__PURE__ */(0, import_jsx_runtime22.jsx)(_Stack, _objectSpread(_objectSpread({
    align: "center"
  }, props), {}, {
    direction: "column",
    ref: ref
  }));
});
_VStack.displayName = "VStack";

// src/text.tsx
var import_system24 = require("@chakra-ui/system");
var import_shared_utils11 = require("@chakra-ui/shared-utils");
var import_object_utils2 = require("@chakra-ui/object-utils");
var import_jsx_runtime23 = require("react/jsx-runtime");
var _Text = (0, import_system24.forwardRef)(function Text2(props, ref) {
  var styles = (0, import_system24.useStyleConfig)("Text", props);
  var _ref14 = (0, import_system24.omitThemingProps)(props),
    className = _ref14.className,
    align = _ref14.align,
    decoration = _ref14.decoration,
    casing = _ref14.casing,
    rest = _objectWithoutProperties(_ref14, _excluded23);
  var aliasedProps = (0, import_object_utils2.compact)({
    textAlign: props.align,
    textDecoration: props.decoration,
    textTransform: props.casing
  });
  return /* @__PURE__ */(0, import_jsx_runtime23.jsx)(import_system24.chakra.p, _objectSpread(_objectSpread(_objectSpread({
    ref: ref,
    className: (0, import_shared_utils11.cx)("chakra-text", props.className)
  }, aliasedProps), rest), {}, {
    __css: styles
  }));
});
_Text.displayName = "Text";

// src/wrap.tsx
var import_shared_utils12 = require("@chakra-ui/shared-utils");
var import_system25 = require("@chakra-ui/system");
var import_react4 = require("react");
var import_jsx_runtime24 = require("react/jsx-runtime");
var _Wrap = (0, import_system25.forwardRef)(function Wrap2(props, ref) {
  var _props$spacing2 = props.spacing,
    spacing = _props$spacing2 === void 0 ? "0.5rem" : _props$spacing2,
    spacingX = props.spacingX,
    spacingY = props.spacingY,
    children = props.children,
    justify = props.justify,
    direction = props.direction,
    align = props.align,
    className = props.className,
    shouldWrapChildren = props.shouldWrapChildren,
    rest = _objectWithoutProperties(props, _excluded24);
  var _children = (0, import_react4.useMemo)(function () {
    return shouldWrapChildren ? import_react4.Children.map(children, function (child, index) {
      return /* @__PURE__ */(0, import_jsx_runtime24.jsx)(_WrapItem, {
        children: child
      }, index);
    }) : children;
  }, [children, shouldWrapChildren]);
  return /* @__PURE__ */(0, import_jsx_runtime24.jsx)(import_system25.chakra.div, _objectSpread(_objectSpread({
    ref: ref,
    className: (0, import_shared_utils12.cx)("chakra-wrap", className)
  }, rest), {}, {
    children: /* @__PURE__ */(0, import_jsx_runtime24.jsx)(import_system25.chakra.ul, {
      className: "chakra-wrap__list",
      __css: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: justify,
        alignItems: align,
        flexDirection: direction,
        listStyleType: "none",
        gap: spacing,
        columnGap: spacingX,
        rowGap: spacingY,
        padding: "0"
      },
      children: _children
    })
  }));
});
_Wrap.displayName = "Wrap";
var _WrapItem = (0, import_system25.forwardRef)(function WrapItem2(props, ref) {
  var className = props.className,
    rest = _objectWithoutProperties(props, _excluded25);
  return /* @__PURE__ */(0, import_jsx_runtime24.jsx)(import_system25.chakra.li, _objectSpread({
    ref: ref,
    __css: {
      display: "flex",
      alignItems: "flex-start"
    },
    className: (0, import_shared_utils12.cx)("chakra-wrap__listitem", className)
  }, rest));
});
_WrapItem.displayName = "WrapItem";

// src/indicator.tsx
var import_breakpoint_utils5 = require("@chakra-ui/breakpoint-utils");
var import_system26 = require("@chakra-ui/system");
var import_react5 = require("react");
var import_jsx_runtime25 = require("react/jsx-runtime");
var _Indicator = (0, import_system26.forwardRef)(function Indicator2(props, ref) {
  var offsetX = props.offsetX,
    offsetY = props.offsetY,
    _props$offset = props.offset,
    offset = _props$offset === void 0 ? "0" : _props$offset,
    _props$placement = props.placement,
    placement = _props$placement === void 0 ? "top-end" : _props$placement,
    rest = _objectWithoutProperties(props, _excluded26);
  var styles = (0, import_react5.useMemo)(function () {
    return {
      display: "inline-flex",
      justifyContent: "center",
      alignItems: "center",
      position: "absolute",
      insetBlockStart: (0, import_breakpoint_utils5.mapResponsive)(placement, function (v) {
        var _v$split = v.split("-"),
          _v$split2 = _slicedToArray(_v$split, 1),
          side = _v$split2[0];
        var map = {
          top: offsetY != null ? offsetY : offset,
          middle: "50%",
          bottom: "auto"
        };
        return map[side];
      }),
      insetBlockEnd: (0, import_breakpoint_utils5.mapResponsive)(placement, function (v) {
        var _v$split3 = v.split("-"),
          _v$split4 = _slicedToArray(_v$split3, 1),
          side = _v$split4[0];
        var map = {
          top: "auto",
          middle: "50%",
          bottom: offsetY != null ? offsetY : offset
        };
        return map[side];
      }),
      insetStart: (0, import_breakpoint_utils5.mapResponsive)(placement, function (v) {
        var _v$split5 = v.split("-"),
          _v$split6 = _slicedToArray(_v$split5, 2),
          align = _v$split6[1];
        var map = {
          start: offsetX != null ? offsetX : offset,
          center: "50%",
          end: "auto"
        };
        return map[align];
      }),
      insetEnd: (0, import_breakpoint_utils5.mapResponsive)(placement, function (v) {
        var _v$split7 = v.split("-"),
          _v$split8 = _slicedToArray(_v$split7, 2),
          align = _v$split8[1];
        var map = {
          start: "auto",
          center: "50%",
          end: offsetX != null ? offsetX : offset
        };
        return map[align];
      }),
      translate: (0, import_breakpoint_utils5.mapResponsive)(placement, function (v) {
        var _v$split9 = v.split("-"),
          _v$split10 = _slicedToArray(_v$split9, 2),
          side = _v$split10[0],
          align = _v$split10[1];
        var mapX = {
          start: "-50%",
          center: "-50%",
          end: "50%"
        };
        var mapY = {
          top: "-50%",
          middle: "-50%",
          bottom: "50%"
        };
        return "".concat(mapX[align], " ").concat(mapY[side]);
      })
    };
  }, [offset, offsetX, offsetY, placement]);
  return /* @__PURE__ */(0, import_jsx_runtime25.jsx)(import_system26.chakra.div, _objectSpread({
    ref: ref,
    __css: styles
  }, rest));
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  AbsoluteCenter: _AbsoluteCenter,
  AspectRatio: _AspectRatio,
  Badge: _Badge,
  Box: _Box,
  Center: _Center,
  Circle: _Circle,
  Code: _Code,
  Container: _Container,
  Divider: _Divider,
  Flex: _Flex,
  Grid: _Grid,
  GridItem: _GridItem,
  HStack: _HStack,
  Heading: _Heading,
  Highlight: _Highlight,
  Indicator: _Indicator,
  Kbd: _Kbd,
  Link: _Link,
  LinkBox: _LinkBox,
  LinkOverlay: _LinkOverlay,
  List: _List,
  ListIcon: _ListIcon,
  ListItem: _ListItem,
  Mark: _Mark,
  OrderedList: _OrderedList,
  SimpleGrid: _SimpleGrid,
  Spacer: _Spacer,
  Square: _Square,
  Stack: _Stack,
  StackDivider: _StackDivider,
  StackItem: _StackItem,
  Text: _Text,
  UnorderedList: _UnorderedList,
  VStack: _VStack,
  Wrap: _Wrap,
  WrapItem: _WrapItem,
  useHighlight: _useHighlight,
  useListStyles: _useListStyles
});